import { render, staticRenderFns } from "./agent_config_edit.vue?vue&type=template&id=dcf596ac&scoped=true"
import script from "./agent_config_edit.vue?vue&type=script&lang=ts"
export * from "./agent_config_edit.vue?vue&type=script&lang=ts"
import style0 from "./agent_config_edit.vue?vue&type=style&index=0&id=dcf596ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf596ac",
  null
  
)

export default component.exports